export const GET_LOG_GENERAL_START = 'GET_LOG_ENTREGAS_START';
export const GET_LOG_GENERAL_ERROR = 'GET_LOG_ENTREGAS_ERROR';
export const GET_LOG_GENERAL_SUCCESS = 'GET_LOG_ENTREGAS_SUCCESS';

export const SET_FILTER_PARAMS = 'SET_FILTER_PARAMS';
export const RESET_LOG_GENERAL_STATE = 'RESET_LOG_GENERAL_STATE';